export default __webpack_public_path__ + "static/media/dice.548639de.svg";